<template>
  <div class="ma-6">
    <div class="page-header-left">
      <h2 class="pr-3">Monitoring Balance</h2>
      <v-spacer></v-spacer>
      <div class="listtotal pt-2">
        <v-card style="border: thin solid rgba(0,0,0,.12)" class="listtotal border_all mr-2" elevation="0">
          <v-sheet class="" color="green" width="50" height="50" elevation="0">
            <v-icon dark large class="icondash">account_balance</v-icon>
          </v-sheet>
          <div class="pl-2 pr-10">
            <div>Saldo Akun</div>
            <div>{{formatAngka(monitoringsaldo.saldoakun)}}</div>
          </div>
        </v-card>
        <v-card class="listtotal mr-2" style="border: thin solid rgba(0,0,0,.12)" elevation="0">
          <v-sheet class="" color="green" width="50" height="50" elevation="0">
            <v-icon dark large class="icondash">account_balance_wallet</v-icon>
          </v-sheet>
          <div class="pl-2 pr-10">
            <div>
              <div>Saldo Member</div>
              <div>{{formatAngka(monitoringsaldo.saldomember)}}</div>
            </div>
          </div>
        </v-card>
        <v-card class="listtotal mr-2" style="border: thin solid rgba(0,0,0,.12)" elevation="0">
          <v-sheet class="" color="green" width="50" height="50" elevation="0">
            <v-icon dark large class="icondash">arrow_forward_ios</v-icon>
          </v-sheet>
          <div class="pl-2 pr-10">
            <div>Cashout</div>
            <div>{{formatAngka(monitoringsaldo.cashout)}}</div>
          </div>
        </v-card>
        <v-card class="listtotal" style="border: thin solid rgba(0,0,0,.12)" elevation="0">
          <v-sheet class="" color="green" width="50" height="50" elevation="0">
            <v-icon dark large class="icondash">sync</v-icon>
          </v-sheet>
          <div class="pl-2 pr-10">
            <div>Balance</div>
            <div :class="saldo<0?`red--text`:`green--text`"><b>{{formatAngka(saldo)}}</b></div>
          </div>
        </v-card>
      </div>
    </div>
    <div class="mt-4 pr-0 pl-0 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)">
      <v-toolbar elevation="0">
        <v-spacer/>
        <v-btn small elevation="0" class="ml-2" color="primary" @click.native="setdialogtrfdana(true)">
          <v-icon dark>refresh</v-icon>Transfer Kas
        </v-btn>
        <v-btn small elevation="0" class="ml-2" color="primary" @click.native="refreshSaldo">
          <v-icon dark>refresh</v-icon>Refresh
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-data-table
          :headers="headers"
          :items="account"
          class="elevation-0"
          item-key="id"
          :loading="loading">
        <template v-slot:item.balance="{ item }">
          <div  class="text-right">
            {{formatAngka(item.balance)}}
          </div>
        </template>
        <template v-slot:item.updateat="{ item }">
          <div  class="">
            {{formatDate(item.updateat)}}
          </div>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Utils from '@/plugins/utils'
import moment from 'moment'

export default {
  name: 'AccountBank',
  data: () => ({
    headers: [
      {
        text: 'Code',
        value: 'code'
      },
      {
        text: 'Nama Akun',
        value: 'name'
      },
      {
        text: 'Member',
        value: 'balance',
        align: 'right'
      },
      {
        text: 'updateat',
        value: 'updateat'
      }
    ]
  }),
  mounted () {
    this.getMonitoringsaldo()
    this.getAccount()
  },
  computed: {
    ...mapState('AdmStore', ['account', 'loading', 'monitoringsaldo']),
    saldo () {
      return parseInt(this.monitoringsaldo.saldoakun - (this.monitoringsaldo.saldomember + this.monitoringsaldo.cashout + this.monitoringsaldo.pending))
    }
  },
  methods: {
    ...mapActions('AdmStore', ['getAccount', 'getMonitoringsaldo', 'setdialogtrfdana']),
    formatAngka (val) {
      return Utils.formatAngka(val)
    },
    formatDate (value) {
      return moment(value).add(0, 'hours').format('YYYY/MM/DD HH:mm:ss')
    },
    refreshSaldo () {
      this.getMonitoringsaldo()
      this.getAccount()
    }
  }
}
</script>

<style scoped>
.listtotal {
  display:flex;
  flex-wrap: wrap;
}
.icondash {
  margin-left: 6px;
  margin-top: 5px;
}
</style>
